export default __webpack_public_path__ + "static/media/debate_17.806bca20.JPG";